// Documentation for the rest apis associated with this resource can be found at: https://enterprise-confluence.aexp.com/confluence/display/DLMM/ICaaS+API+Specs
/* istanbul ignore file */
import getImageViewerDocUploadApiUrl from '../../selectors/getImageViewerDocuploadApiUrl';
import getDefaultHeaders from '../utils/getDefaultHeaders';

export default {
  fetch(id, action, state) {
    const {
      formDataAPI, realtime, documentId, fileId, correlationId,
    } = id;
    let headers = {
      'correlation-id': correlationId,
      'icaas-correlation-id': correlationId,
    };
    if (formDataAPI) {
      headers = { ...headers };
    } else {
      headers = {
        ...headers,
        ...getDefaultHeaders(),
      };
    }
    const endpoint = realtime
      ? '/realtime'
      : `/docs${documentId ? `/${documentId}` : ''}${fileId ? `/file/${fileId}` : ''}`;
    return {
      url: `${getImageViewerDocUploadApiUrl(state)}/servicing/v1/communications${endpoint}`,
      opts: {
        // ...getProductOpts(headers),
        headers,
        credentials: 'include',
      },
    };
  },
  transformData: (data) => ({
    id: data.documentId,
    ...data,
  }),
};
